<script>
// add [ref="scrollTo"] to an element
// [extends: ScrollTo] on the vue component

import { scrollToElement } from '@/utils';

export default {
  mounted() {
    scrollToElement(this.$refs.scrollTo, true);
  }
};
</script>